// extracted by mini-css-extract-plugin
module.exports = {"issuable-coupons":"CouponIssuable_issuable-coupons__3eNik","contents":"CouponIssuable_contents__1Pi-d"};